import { has, orderBy } from "lodash";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import { Link as RouterLink } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { useEffect, useCallback, useState } from "react";
// material
import { Box, Grid, Button, Skeleton, Container, Stack } from "@mui/material";
// redux
// hooks
// routes
// @types
import { Post, BlogState } from "../types/blog";
// components
import {
  BlogPostCard,
  BlogPostsSort,
  BlogPostsSearch,
} from "../components/blog";
import { useBlogStore } from "../store/blogStore";

// ----------------------------------------------------------------------

const SORT_OPTIONS = [
  { value: "latest", label: "Latest" },
  { value: "popular", label: "Popular" },
  { value: "oldest", label: "Oldest" },
];

// ----------------------------------------------------------------------

const applySort = (posts: Post[], sortBy: string) => {
  if (sortBy === "latest") {
    return orderBy(posts, ["createdAt"], ["desc"]);
  }
  if (sortBy === "oldest") {
    return orderBy(posts, ["createdAt"], ["asc"]);
  }
  if (sortBy === "popular") {
    return orderBy(posts, ["view"], ["desc"]);
  }
  return posts;
};

const SkeletonLoad = (
  <Grid container spacing={3} sx={{ mt: 2 }}>
    {[...Array(4)].map((_, index) => (
      <Grid>
        <Skeleton
          variant="rectangular"
          width="100%"
          sx={{ height: 200, borderRadius: 2 }}
        />
        <Box sx={{ display: "flex", mt: 1.5 }}>
          <Skeleton variant="circular" sx={{ width: 40, height: 40 }} />
          <Skeleton variant="text" sx={{ mx: 1, flexGrow: 1 }} />
        </Box>
      </Grid>
    ))}
  </Grid>
);

export default function BlogPosts() {
  const [filters, setFilters] = useState("latest");
  const { posts } = useBlogStore();

  const sortedPosts = applySort(posts, filters);
  const onScroll = useCallback(() => {}, []);

  const handleChangeSort = (value?: string) => {
    if (value) {
      setFilters(value);
    }
  };

  return (
    <Container maxWidth={"lg"}>
      <Stack
        mb={5}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <BlogPostsSearch />
        <BlogPostsSort
          query={filters}
          options={SORT_OPTIONS}
          onSort={handleChangeSort}
        />
      </Stack>

      <InfiniteScroll
        next={onScroll}
        hasMore={false}
        loader={SkeletonLoad}
        dataLength={posts.length}
        style={{ overflow: "inherit" }}
      >
        <Grid container spacing={3}>
          {sortedPosts.map((post, index) => (
            <BlogPostCard key={post.id} post={post} index={index} />
          ))}
        </Grid>
      </InfiniteScroll>
    </Container>
  );
}
